module.exports = __webpack_public_path__ + "img/service-item-5.b7cb620a.jpeg";